// Third-party libraries
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { FluxTooltip } from "@meltwater/flux-web-components-react";
import { Routes, Route } from "react-router-dom";
// Assets
import TritonLogo from "../../assets/triton_logo_150_transparent.png";
// CSS / Styles
import styles from "./dashboards.module.css";
// Hooks / Providers
import { useCompanyId } from "../../services/CompanyidProvider";
// Components
import Admin from "../../components/admin/admin";
import Company from "../../components/company/company";
import CompanyBadge from "../../components/CompanyBadge/CompanyBadge";
import DuplicateAnalyzer from "../../components/DuplicateAnalyzer/DuplicateAnalyzer";
import Jira from "../../components/jira/jira";
import Jirarelatedtickets from "../../components/jira/jira.relatedtickets";
import JiraSalesforceSearch from "../../components/jira/jira.salesforcesearch";
import JiraSearchLanding from "../../components/jira/JiraSearchLanding";
import Leaderboard from "../../components/Leaderboard/leaderboard";
import SidePanel from "../../components/SidePanel/SidePanel";
import { UserProfileManager } from "../../components/UserProfile";
import EntitlementHistory from "../../components/EntitlementHistory/EntitlementHistory";
// Pages
import Bounces from "../../pages/SendGrid/bounces/bounces";
import CompanyDetail from "../../pages/companydetail/companydetail";
import Newsletters from "../../pages/newsletters/newsletters";
import RestoreCustomdashboard from "../../pages/RestoreCustomdashboard/dashboard";
// Modules / Features
import Audit from "../Audit/audit";
import Companies from "../createCompanies/createCompanies";
import HistoricalContent from "../historicalContent/historicalContent";
import CompanyManagement from "../CompanyManagement/CompanyManagement";
import Home from "../Home/Home";
import MediaRelations from "../MediaRelations/mediarelations";
import Newsletterstatus from "../SendGrid/newsletterstatus";
import SendGridCompany from "../SendGrid/SendGridCompany";
import ScriptRunner from "../ScriptRunner/ScriptRunner";
// interns scriptrunner - Import ScriptRunnerV2 components
import ScriptRunnerV2 from "../ScriptRunnerV2/ScriptRunnerV2";
import ViewScriptsV2 from "../ScriptRunnerV2/ViewScriptsV2";
import UploadScriptsV2 from "../ScriptRunnerV2/UploadScriptsV2";
import ScriptExecuteV2 from "../ScriptRunnerV2/ScriptExecuteV2";
// interns scriptrunner - added workspace editor import
import ScriptWorkspaceV2 from "../ScriptRunnerV2/workspace/ScriptWorkspaceV2";
import NewsletterUnsubscribes from "../NewsletterUnsubscribes/NewsletterUnsubscibes";
import ObjectExplorer from "../ObjectExplorer/objectexplorer";
import Searchexports from "../search/searchexports";
import CompanyUserExport from "../UsersAndWorkspaces/UsersAndWorkspaces";
import SelfServeEntitlements from "../selfServeEntitlements/selfServeEntitlements";
import IntercomLanding from "../Intercom/IntercomLanding";
import IntercomTickets from "../Intercom/IntercomTickets";
import IntercomConversations from "../Intercom/IntercomConversations";
import IntercomConversationDetail from "../Intercom/IntercomConversationDetail";
import IntercomTicketDetail from "../Intercom/IntercomTicketDetail";
import IntercomV2Conversations from "../IntercomV2/IntercomV2Conversations";
import Auth0UserBlocks from "../Auth0UserBlocks/Auth0UserBlocks";
import EntitlementsPage from "../Entitlements/Entitlements";
import OverridesPage from "../Overrides/Overrides";
import UserLookup from '../UserLookup/UserLookup';

export default function Dashboard() {
  const { companyId } = useCompanyId();
  return (
    <div className={styles.Dashboards}>
      <div className={styles.divStyle}>
        <Grid container>
          <Grid item xs={12} className={styles.GSDHeader}>
            <Toolbar className={styles.toolbar}>
              <IconButton className={styles.iconButtonStyle}>
                <a href="/home">
                  <img src={TritonLogo} width={64} alt="Triton"></img>
                </a>
                <FluxTooltip arrow placement="bottom-start">
                  GSD Home
                </FluxTooltip>
              </IconButton>
              <Typography
                variant="h5"
                noWrap
                className={styles.headerTitle}
                sx={{
                  flexGrow: 1,
                }}
              >
                GSD Support Admin
              </Typography>

              <div className={styles.userSection}>
                <CompanyBadge companyId={companyId} />
                <UserProfileManager />
              </div>
            </Toolbar>
          </Grid>
          <SidePanel />
          <div className={styles.divStyle}>
            <Grid container>
              <Grid item xs={12}>
                <Routes>
                  <Route
                    path="/"
                    exact
                    element={
                      <div>
                        <Company />
                        <div className={styles.divStyle}>
                          <Home />
                        </div>
                      </div>
                    }
                  />
                  <Route path="/bounces" element={<Bounces />} />
                  <Route
                    path="/Home"
                    exact
                    element={
                      <div>
                        <Company />
                        <Home />
                      </div>
                    }
                  />
                  <Route
                    path="/company-management"
                    element={<CompanyManagement />}
                  />
                  <Route
                    path="/newsletters"
                    exact
                    element={<Newsletters load={true} />}
                  />
                  <Route
                    path="/customDashboard"
                    exact
                    element={
                      <>
                        <Company />
                        <RestoreCustomdashboard />
                      </>
                    }
                  />
                  <Route
                    path="/Dashboard"
                    exact
                    element={
                      <>
                        <Company />
                      </>
                    }
                  />
                  <Route
                    path="/searches"
                    element={
                      <>
                        <Company />
                        <Searchexports />
                      </>
                    }
                  />
                  <Route
                    path="/mediarelations"
                    element={
                      <>
                        <Company />
                        <MediaRelations />
                      </>
                    }
                  />
                  <Route path="/companies" element={<Companies />} />
                  <Route
                    path="/companydetail"
                    element={
                      <>
                        <Company />
                        <CompanyDetail />
                      </>
                    }
                  />
                  <Route
                    path="/companies/history"
                    element={<EntitlementHistory />}
                  />
                  <Route path="/objectexplorer" element={<ObjectExplorer />} />
                  <Route path="/hc" element={<HistoricalContent />} />
                  <Route path="/sse" element={<SelfServeEntitlements />} />
                  <Route path="/intercom" element={<IntercomLanding />} />
                  <Route
                    path="/intercom/tickets"
                    element={<IntercomTickets />}
                  />
                  <Route
                    path="/intercom/tickets/:id"
                    element={<IntercomTicketDetail />}
                  />
                  <Route
                    path="/intercom/conversations"
                    element={<IntercomConversations />}
                  />
                  <Route
                    path="/intercom/conversations/:id"
                    element={<IntercomConversationDetail />}
                  />
                  <Route
                    path="/intercom-v2/conversations"
                    element={<IntercomV2Conversations />}
                  />
                  <Route path="/admin" element={<Admin />} />
                  <Route
                    path="/login"
                    element={
                      <>
                        <Company />
                        <Home />
                      </>
                    }
                  />
                  <Route
                    path="/jira/relatedtickets/:opId/:optouse"
                    exact
                    element={<Jirarelatedtickets />}
                  />
                  <Route
                    path="/jira/salesforce/:salesforceId"
                    exact
                    element={<JiraSalesforceSearch />}
                  />
                  <Route
                    path="/jira/search"
                    exact
                    element={<JiraSearchLanding />}
                  />
                  <Route path="/jira/:issueid" element={<Jira />} />
                  <Route path="/jira" element={<JiraSearchLanding />} />
                  <Route
                    path="/sendgrid/newsletters"
                    element={<Newsletterstatus />}
                  />
                  <Route
                    path="/sendgrid/:companyid/status"
                    element={<SendGridCompany />}
                  />
                  <Route path="/dups" element={<DuplicateAnalyzer />} />
                  <Route path="/audit" element={<Audit />} />
                  <Route path="/script-runner" element={<ScriptRunner />} />

                  {/* interns scriptrunner - added main dashboard route */}
                  <Route
                    path="/script-runner-V2"
                    element={<ScriptRunnerV2 />}
                  />
                  {/* interns scriptrunner - added view scripts route */}
                  <Route
                    path="/script-runner-V2/view"
                    element={<ViewScriptsV2 />}
                  />
                  {/* interns scriptrunner - added upload scripts route */}
                  <Route
                    path="/script-runner-V2/upload"
                    element={<UploadScriptsV2 />}
                  />
                  {/* interns scriptrunner - added execution route */}
                  <Route
                    path="/script-runner-V2/execute/:scriptId/:version"
                    element={<ScriptExecuteV2 />}
                  />
                  {/* interns scriptrunner - added workspace editor route */}
                  <Route
                    path="/script-runner-V2/edit/:scriptId/:version"
                    element={<ScriptWorkspaceV2 />}
                  />

                  <Route
                    path="/newsletter-unsubscribes"
                    element={<NewsletterUnsubscribes />}
                  />
                  <Route
                    path="/users-and-workspaces"
                    element={
                      <>
                        <Company />
                        <CompanyUserExport />
                      </>
                    }
                  />
                  <Route path="/leaderboard" element={<Leaderboard />} />
                  <Route path="/auth0-blocks" element={<Auth0UserBlocks />} />
                  <Route path="/entitlements" element={<EntitlementsPage />} />
                  <Route path="/overrides" element={<OverridesPage />} />
                  <Route path='/user-lookup' element={<UserLookup />} />
                </Routes>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </div>
    </div>
  );
}
